// @flow

import React from 'react';

import { AboutPage } from '../AboutPage';
import { ProjectsPage } from '../ProjectsPage';
import { Footer } from '../Footer';
import './Main.css';

export const PagesEnum = Object.freeze({ 
  'about': 0,
  'projects': 1,
  'contact': 2,
});

export const Pages = [
  'About Me',
  'My Projects',
  'Contact',
]

export class Main extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      page: PagesEnum.about,
      menuShown: false,
    };
  }

  openAbout() {
    this.setState({
      page: PagesEnum.about,
      menuShown: false,
    });
  }

  openProjects() {
    this.setState({
      page: PagesEnum.projects,
      menuShown: false,
    });
  }

  openContact() {
    this.setState({
      page: PagesEnum.contact,
      menuShown: false,
    });
  }

  toggleMenu() {
    console.log("TRYING TO OPEN MENU");
    this.setState({
      page: this.state.page,
      menuShown: !this.state.menuShown,
    });
  }

  render() {
    const dropDownMenu = this.state.menuShown
      ? <div className="menu-dropdown">
          <div className="menu-dropdown-button"
            onClick={() => this.openAbout()}>
            {Pages[0]}
          </div>
          <div className="menu-dropdown-button"
            onClick={() => this.openProjects()}>
            {Pages[1]}
          </div>
          <div className="menu-dropdown-button"
            onClick={() => this.openContact()}>
            {Pages[2]}
          </div>
        </div>
      : null

    const page = this.state.page;

    let pageShown = <AboutPage />;
    switch(page) {
      case PagesEnum.projects:
        pageShown = <ProjectsPage />;
        break;
      default:
        break;
    }

    alert("A quick disclaimer: I am actively working on this site at this very moment, so please don't judge my coding skill because of missing images or broken links.");

    return(
      <div className="main">

        <div className="header">
          <div className="menu" onClick={() => this.toggleMenu()} />
          {dropDownMenu}
          <div className="page-title">
            {Pages[page]}
          </div>
        </div>

        {pageShown}

        <Footer />

      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/Main/Main.js